export const LOAD_PROJECT_DATA = "LOAD_PROJECT_DATA";
export const ERROR_LOADING_PROJECT = "ERROR_LOADING_PROJECT";
export const FETCH_RESOURCES_TRADITIONAL ="FETCH_RESOURCES_TRADITIONAL";
export const LOADING_DATA = "LOADING_DATA";